import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import misionimg from "../../assets/image/mision.webp";
import visionimg from "../../assets/image/vision.webp";
import prinsipimg from "../../assets/image/prinsip.webp";
import vadiimg from "../../assets/image/vaddi.jpg";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import AOS from "aos";
import { ApiLinkContext } from "../../context/ApiLinkContext";
import translations from "../../data/langData";
import { LanguageContext } from "../../context/LanguageContext";
const MissionAndVision = () => {
  const { loading, main, error } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);
  return (
    <>
      <div className="container-fluid mx-5">
        <div className="row">
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Pagination, Autoplay]}
            className="mySwiper2 py-5"
          >
            {main.map((item, index) => {
              return (
                <div className="col-2 bg-primary">
                  <SwiperSlide key={index}>
                    <div className="mainBox">
                      <img src={item.img} alt="" className="img-fluid" />
                      <div className="outline">
                        <div className="mainText" data-aos="fade-up">
                          <h1 className="text-white">
                            {" "}
                            {language == "az"
                              ? item.title
                              : language == "en"
                              ? item.title_en
                              : language == "ru"
                              ? item.title_ru
                              : language == "tr"
                              ? item.title_tr
                              : language == "de"
                              ? item.title_de
                              : language == "pl"
                              ? item.title_pl
                              : ""}
                          </h1>
                          <p
                            dangerouslySetInnerHTML={{ __html:    language == "az"
                            ? item.text
                            : language == "en"
                            ? item.textEn
                            : language == "ru"
                            ? item.textRu
                            : language == "tr"
                            ? item.textTr
                            : language == "de"
                            ? item.textDe
                            : language == "pl"
                            ? item.textPl
                            : "" }}
                            className="text-white"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </div>
              );
            })}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default MissionAndVision;
